<div class="container-fluid min-vh-100 p-1 entity-config-page">
  <div class="entity-config-shell d-flex flex-column gap-2 mx-auto">
    <section class="entity-config-top rounded-4 overflow-hidden shadow-sm mt-2">
      <div class="entity-config-top-hero px-3 px-md-3 py-3">
        <div class="row g-2 align-items-start flex-nowrap">
          <div class="col">
            <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">{{ hero.title }}</h1>
            <p class="entity-page-subtitle text-white mb-0">
              {{ hero.description }}
            </p>
          </div>
        </div>
      </div>

      <div class="px-3 px-md-3 pb-3">
        <section class="row entity-config-top-metrics g-3 g-xl-4 align-items-stretch">
          <div class="col-12 mt-2">
            <article class="card border border-purple border-opacity-50 shadow-sm rounded-4 h-100">
              <div class="card-body p-3 p-lg-4 d-flex flex-column gap-3">
                <div class="d-flex flex-column flex-lg-row justify-content-between align-items-start gap-3">
                  <div class="d-flex align-items-start gap-3">
                    <div class="entity-icon-surface rounded-4 d-inline-flex align-items-center justify-content-center p-2 px-3 flex-shrink-0">
                      <i class="bi bi-diagram-3 fs-3"></i>
                    </div>
                    <div>
                      <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-1 mb-1">
                        <span class="text-dark text-x">{{ topBar.label }}</span>
                        <span class="fw-semibold text-dark text-x">{{ topBar.formName }}</span>
                      </div>
                      <p class="text-secondary text-xs mb-0">
                        Build the structure for this form by organizing main sections, sub sections, and question groupings.
                      </p>
                    </div>
                  </div>

                  <div class="d-flex flex-wrap align-items-center gap-2 justify-content-end">
                    <router-link
                      :to="{ name: 'ManageQuestions', query: { form_id: topBar.formId, form_name: topBar.formName} }"
                      class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
                    >
                      Manage Questions
                    </router-link>
                    <router-link
                      :to="{ name: 'PreviewForm', query: { form_id: topBar.formId, form_name: topBar.formName} }"
                       class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
                    >
                      Preview Form
                    </router-link>
                    <button
                      type="button"
                       class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
                      data-bs-toggle="modal"
                      data-bs-target="#create_main_section_modal"
                      @click="open_main_section_modal"
                    >
                      <span class="d-inline-flex align-items-center justify-content-end">
                        <i class="bi bi-plus-lg me-2"></i>
                      </span>
                      <span>{{ actions.add_section_label }}</span>
                    </button>
                  </div>
                </div>

                <div v-if="is_verification_form_context" class="mt-3">
                  <div class="rounded-4 border bg-white p-3">
                    <div class="d-flex flex-column flex-lg-row align-items-start justify-content-between gap-3">
                      <div class="min-w-0">
                        <div class="d-flex align-items-center gap-2">
                          <i class="bi bi-exclamation-circle text-danger"></i>
                          <div class="fw-semibold text-xs">API field questions needed</div>
      
                        </div>
                        <div class="text-secondary text-xxs mt-1">
                          Create a question for each field below, then map them in Service Setup.
                        </div>
                      </div>

                      <div class="text-secondary text-xxs d-flex align-items-center gap-2" v-if="verification_guidance_loading">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <span>Loading…</span>
                      </div>
                    </div>

                    <div v-if="(verification_services || []).length" class="d-flex flex-wrap gap-2 mt-3">
                      <button
                        v-for="service in (verification_services || [])"
                        :key="service.id"
                        type="button"
                        class="btn btn-sm rounded-pill px-3 text-xs"
                        :class="String(verification_active_service_id) === String(service.id) ? 'workflow-tab-active' : 'workflow-tab-inactive'"
                        @click="set_active_verification_service(service.id)"
                      >
                        {{ (service.name || service.title || 'Service') }}
                        <span class="ms-2 text-xxs">
                          {{ (verification_required_fields_by_service?.[String(service.id)] || []).length }}
                        </span>
                      </button>
                    </div>

                    <div v-if="verification_active_service" class="mt-3">
                      <div class="text-xs text-secondary fw-bold mb-2">
                        Questions needed for {{ verification_active_service.name || verification_active_service.title }}
                      </div>

                      <div class="d-flex flex-column gap-2" v-if="(verification_active_required_fields || []).length">
                        <ul class="mb-0 ps-4 text-xs">
                          <li
                            v-for="field in (verification_active_required_fields || [])"
                            :key="`required-${verification_active_service_id}-${field}`"
                            class="py-1"
                          >
                            <span class="fw-semibold">{{ format_required_field_label(field) }}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </section>
      </div>
    </section>

    <div class="row g-4 align-items-start">
      <main class="col-12 col-md-12">
        <section class="entity-inventory-panel rounded-4 border shadow-sm p-3 position-relative bg-transparent">
          <div class="d-grid gap-4">
            <div v-if="!section_groups.length" class="ms-4">
              <div class="card border border-purple border-opacity-25 shadow-sm rounded-4 bg-white">
                <div class="card-body p-4 text-dark text-xs d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3">
                  <div class="flex-grow-1">
                    No sections yet. Use the buttons to add a main section or create a sub section directly.
                  </div>
                  <div class="d-flex flex-wrap gap-2 justify-content-md-end">
                    <button
                      type="button"
                      class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
                      data-bs-toggle="modal"
                      data-bs-target="#create_main_section_modal"
                      @click="open_main_section_modal"
                    >
                      <span class="d-inline-flex align-items-center justify-content-end">
                        <i class="bi bi-plus-lg me-2"></i>
                      </span>
                      <span>{{ actions.add_section_label }}</span>
                    </button>
                    <button
                      type="button"
                      class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
                      data-bs-toggle="modal"
                      data-bs-target="#create_sub_section_modal"
                      @click="open_sub_section_modal()"
                    >
                      <span class="d-inline-flex align-items-center justify-content-end">
                        <i class="bi bi-plus-lg me-2"></i>
                      </span>
                      <span>{{ actions.add_sub_section_label }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

                <article
                  v-for="(group, group_index) in section_groups"
                  :key="group.main_section_name"
                  class="card bg-transparent border-0 rounded-4"
                  :draggable="!(reordering_main_sections || reordering_sub_sections || reordering_section_questions)"
                  @dragstart="handle_main_section_drag_start($event, group, group_index)"
                  @dragend="handle_main_section_drag_end"
                  @dragover="handle_drag_over"
                  @drop="handle_main_section_drop(group, group_index)"
                >
                  <div class="card-header  entity-bg-purple border-bottom  d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 py-3 px-4">
                    <div class="d-flex align-items-start gap-2">
                      <DragHandle
                        title="Drag to reorder main section"
                        :disabled="reordering_main_sections || reordering_sub_sections || reordering_section_questions"
                      />

                      <div>
                      <p class="text-xxs text-uppercase text-dark mb-1">Main Section</p>
                      <div class="d-flex align-items-center gap-2">
                        <p class="text-dark fw-bold text-x mb-0">{{ group.main_section_name }}</p>
                        <button
                          type="button"
                          class="btn btn-link text-decoration-none text-dark p-0"
                          data-bs-toggle="modal"
                          data-bs-target="#edit_main_section_modal"
                          @click="open_edit_main_section_modal(group)"
                          :disabled="group.is_deleting"
                          aria-label="Edit main section"
                        >
                          <i class="bi bi-pencil-square fs-6"></i>
                        </button>
                        <button
                          type="button"
                          class="btn btn-link text-decoration-none text-dark p-0"
                          @click="delete_main_section(group)"
                          :disabled="group.is_deleting"
                          aria-label="Delete main section"
                        >
                          <span
                            v-if="group.is_deleting"
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <i v-else class="bi bi-x-lg fs-6"></i>
                        </button>
                      </div>
                      </div>
                    </div>

                    <div class="d-flex align-items-center gap-2 flex-wrap">
                      <button
                        type="button"
                        class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
                        data-bs-toggle="modal"
                        data-bs-target="#create_sub_section_modal"
                        @click="open_sub_section_modal(group.form_main_section_id)"
                      >
                        <i class="bi bi-plus-lg me-2"></i>
                        {{ actions.add_sub_section_label }}
                      </button>
                    </div>
                  </div>

                  <div class="card-body p-3 p-md-4 position-relative overflow-hidden">
                    <div class="position-absolute top-0 bottom-0 ms-3">
                      <div class="h-100 border-start border-1 border-secondary border-opacity-20 mt-5 mb-4"></div>
                    </div>
                    <div class="d-grid gap-3">
                      <article
                        v-for="(sub_section, sub_section_index) in group.sections"
                        :key="sub_section.id"
                        class="d-flex align-items-start gap-3 position-relative"
                        :draggable="!(reordering_main_sections || reordering_sub_sections || reordering_section_questions)"
                        @dragstart="handle_sub_section_drag_start($event, group, sub_section, sub_section_index)"
                        @dragend="handle_sub_section_drag_end"
                        @dragover="handle_drag_over"
                        @drop="handle_sub_section_drop(group, sub_section, sub_section_index)"
                      >
                        <div class="flex-shrink-0 pt-3">
                          <div class="position-relative z-1 d-flex align-items-center justify-content-center rounded-3 fw-bold shadow-sm section-step-badge bg-primary text-white">
                            {{ sub_section.order_number || sub_section_index + 1 }}
                          </div>
                        </div>

                        <div class="flex-grow-1">
                          <div class="card border border-0 shadow rounded-4 bg-white">
                            <div class="card-body p-4">
                              <div class="d-flex justify-content-between align-items-start gap-3">
                                <button
                                  type="button"
                                  class="btn btn-link text-decoration-none p-0 flex-grow-1 text-start"
                                >
                                  <div class="d-flex align-items-start gap-2">
                                    <DragHandle
                                      title="Drag to reorder sub section"
                                      icon-class="fs-6"
                                      :disabled="reordering_main_sections || reordering_sub_sections || reordering_section_questions"
                                    />

                                    <div>
                                      <p class="text-xxs text-uppercase text-secondary mb-1">Sub Section</p>
                                      <p class="text-x fw-bold text-dark mb-1">{{ sub_section.name }}</p>
                                      <p class="text-secondary text-x mb-0">
                                        {{ sub_section.questions.length }} question(s)
                                      </p>
                                    </div>
                                  </div>
                                </button>

                                <div class="d-flex align-items-center gap-2 flex-shrink-0">
                                  <button
                                    type="button"
                                    class="btn btn-link text-decoration-none text-dark p-0"
                                    data-bs-toggle="modal"
                                    data-bs-target="#edit_sub_section_modal"
                                    @click.stop="open_edit_section_modal(sub_section)"
                                    :disabled="sub_section.is_deleting"
                                    aria-label="Edit subsection"
                                  >
                                    <i class="bi bi-pencil-square fs-6"></i>
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-link text-decoration-none text-dark p-0"
                                    @click.stop="delete_sub_section(sub_section)"
                                    :disabled="sub_section.is_deleting"
                                    aria-label="Delete subsection"
                                  >
                                    <span
                                      v-if="sub_section.is_deleting"
                                      class="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    <i v-else class="bi bi-x-lg fs-6"></i>
                                  </button>

                                  <button
                                    type="button"
                                    class="btn btn-link text-decoration-none text-dark p-0"
                                    @click.stop="toggle_section(sub_section)"
                                    aria-label="Toggle subsection"
                                  >
                                    <i
                                      class="bi text-dark fs-4 lh-1"
                                      :class="sub_section.expanded ? 'bi-chevron-up' : 'bi-chevron-down'"
                                    
                                    ></i>
                                  </button>
                                </div>
                              </div>

                              <div v-if="sub_section.expanded" class="mt-4 d-grid gap-2">
                                <p v-if="sub_section.description" class="text-secondary small mb-2">
                                  {{ sub_section.description }}
                                </p>

                                <div
                                  v-for="(question, question_index) in sub_section.questions"
                                  :key="question.id"
                                  class="bg-light rounded-3 border border-1 border-white shadow-sm p-2 d-flex align-items-center gap-3"
                                  :draggable="!(reordering_main_sections || reordering_sub_sections || reordering_section_questions)"
                                  @dragstart="handle_question_drag_start($event, sub_section, question, question_index)"
                                  @dragend="handle_question_drag_end"
                                  @dragover="handle_drag_over"
                                  @drop="handle_question_drop(sub_section, question, question_index)"
                                >
                                  <DragHandle
                                    title="Drag to reorder question"
                                    :disabled="reordering_main_sections || reordering_sub_sections || reordering_section_questions"
                                  />
                                  <div class="flex-grow-1">
                                    <span class="text-dark text-xs fw-semibold d-block">{{ question.text }}</span>
                                    <span v-if="question.type_label" class="text-xxs text-uppercase text-secondary">
                                      {{ question.type_label }}
                                    </span>
                                  </div>
                                  <button
                                  type="button"
                                  class="btn btn-link text-decoration-none text-dark p-0 ms-auto"
                                  data-bs-toggle="modal"
                                  data-bs-target="#edit_question_modal"
                                  @click="open_edit_question_modal(sub_section, question)"
                                  :disabled="question.is_unassigning"
                                >
                                    <i class="bi bi-pencil-square fs-6"></i>
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-link text-decoration-none text-dark p-0"
                                    @click="unassign_question(sub_section, question)"
                                    :disabled="question.is_unassigning"
                                    aria-label="Unassign question"
                                  >
                                    <span
                                      v-if="question.is_unassigning"
                                      class="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    <i v-else class="bi bi-x-lg fs-6"></i>
                                  </button>
                                </div>

                                <div class="d-flex flex-nowrap align-items-stretch gap-2">
                                  <button
                                    type="button"
                                    class="btn btn-light border border-3 border-secondary border-opacity-25 rounded-3 py-2 text-dark fw-semibold text-x border-dashed flex-fill"
                                    data-bs-toggle="modal"
                                    data-bs-target="#assign_existing_question_modal"
                                    @click="open_assign_existing_question_modal(sub_section)"
                                  >
                                    <i class="bi bi-link-45deg me-2"></i>
                                    {{ actions.assign_existing_question_label }}
                                  </button>

                                  <button
                                    type="button"
                                    class="btn btn-light border border-3 border-secondary border-opacity-25 rounded-3 py-2 text-dark fw-semibold text-x border-dashed flex-fill"
                                    data-bs-toggle="modal"
                                    data-bs-target="#create_question_modal"
                                    @click="open_question_modal(sub_section)"
                                  >
                                    <i class="bi bi-plus-lg me-2"></i>
                                    {{ actions.add_question_label }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </article>
                    </div>
                  </div>
                </article>

          </div>
        </section>
      </main>
    </div>
  </div>

  <teleport to="body">
    <div
      class="modal fade"
      id="create_main_section_modal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-x">Create Main Section</p>
            <button type="button" class="modal-btn-close btn-close" aria-label="Close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <div class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xs d-block">Mode:</label>
              <div class="d-flex gap-3 flex-wrap">
                <label class="d-inline-flex align-items-center gap-2 text-xs">
                  <input v-model="main_section_mode" type="radio" value="new" />
                  <span>Create new main section</span>
                </label>
                <label class="d-inline-flex align-items-center gap-2 text-xs">
                  <input v-model="main_section_mode" type="radio" value="reuse" />
                  <span>Reuse existing main section</span>
                </label>
              </div>
            </div>

            <div v-if="main_section_mode === 'reuse'" class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xs">Existing Main Section:</label>
              <select
                v-model="new_main_section.existing_main_section_id"
                class="modal-form-select form-select text-xs"
              >
                <option value="">Select a main section</option>
                <option
                  v-for="item in reusable_main_section_options"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
              <small v-if="!reusable_main_section_options.length" class="text-muted p-2 text-xs d-block">
                No reusable main sections are available yet.
              </small>
            </div>

            <div class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xs">Main Section Name:</label>
              <input
                type="text"
                v-model.trim="new_main_section.main_section_name"
                class="modal-form-control form-control text-xs"
                placeholder="Enter main section name"
                :disabled="main_section_mode === 'reuse'"
              />
              <small v-if="main_section_name_error" class="text-danger p-2 text-xs">
                Please enter or select a main section name
              </small>
            </div>

            <div class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xs">Order Number:</label>
              <input
                type="number"
                min="1"
                step="1"
                v-model.number="new_main_section.order_number"
                class="modal-form-control form-control text-xs"
                placeholder="e.g. 1"
                inputmode="numeric"
              />
              <small v-if="order_number_error" class="text-danger p-2 text-xs fw-bold">
                Order number must be a positive whole number
              </small>
            </div>
          </div>
          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button
              type="button"
              class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
              @click="create_main_section"
              :disabled="creating_main_section"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <div
      class="modal fade"
      id="create_sub_section_modal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-x">Create Sub Section</p>
            <button type="button" class="modal-btn-close btn-close" aria-label="Close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <div class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xs">Main Section (Optional):</label>
              <select
                v-model="active_main_section_id"
                class="modal-form-select form-select text-xs"
              >
                <option value="">No main section</option>
                <option
                  v-for="group in section_groups"
                  :key="group.form_main_section_id ?? group.main_section_name"
                  :value="group.form_main_section_id"
                >
                  {{ group.main_section_name }}
                </option>
              </select>
            </div>

            <div class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xs d-block">Mode:</label>
              <div class="d-flex gap-3 flex-wrap">
                <label class="d-inline-flex align-items-center gap-2 text-xs">
                  <input v-model="sub_section_mode" type="radio" value="new" />
                  <span>Create new sub section</span>
                </label>
                <label class="d-inline-flex align-items-center gap-2 text-xs">
                  <input v-model="sub_section_mode" type="radio" value="reuse" />
                  <span>Reuse existing sub section</span>
                </label>
              </div>
            </div>

            <div v-if="sub_section_mode === 'reuse'" class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xs">Existing Sub Section:</label>
              <select
                v-model="new_sub_section.existing_section_id"
                class="modal-form-select form-select text-xs"
              >
                <option value="">Select a sub section</option>
                <option
                  v-for="item in reusable_sub_section_options"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
              <small v-if="!reusable_sub_section_options.length" class="text-muted p-2 text-xs d-block">
                No reusable sub sections are available yet.
              </small>
            </div>

            <div class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xs">Sub Section Name:</label>
              <input
                type="text"
                v-model.trim="new_sub_section.section_name"
                class="modal-form-control form-control text-xs"
                placeholder="Enter sub section name"
                :disabled="sub_section_mode === 'reuse'"
              />
              <small v-if="sub_section_name_error" class="text-danger p-2 text-xs">
                Please enter or select a sub section name
              </small>
            </div>

            <div class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xs">Order Number:</label>
              <input
                type="number"
                min="1"
                step="1"
                v-model.number="new_sub_section.order_number"
                class="modal-form-control form-control text-xs"
                placeholder="e.g. 1"
                inputmode="numeric"
              />
              <small v-if="order_number_error" class="text-danger p-2 text-xs fw-bold">
                Order number must be a positive whole number
              </small>
            </div>
          </div>
          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button
              type="button"
              class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
              @click="create_sub_section"
              :disabled="creating_main_section"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <div
      class="modal fade"
      id="assign_existing_question_modal"
      tabindex="-1"
      aria-labelledby="assign_existing_question_modal_label"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content bg-white rounded-4 p-0">
          <div class="modal-header border-bottom-0 cute-header">
            <div>
              <p class="modal-title text-white text-x mb-1" id="assign_existing_question_modal_label">
                Assign Questions
              </p>
              <p class="text-white text-s mb-0">
                To Main Section : {{ active_assign_main_section_label ? active_assign_main_section_label + ' / ' : '' }} Sub-section : {{ active_assign_section_label }}
              </p>
            </div>
            <button
              type="button"
              class="modal-btn-close btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="close_assign_existing_question_modal"
            ></button>
          </div>
          <div class="modal-body py-3">
            <div class="card mb-0 border-0 shadow-none">
              <div class="card-body p-0">
                <div v-if="is_loading_questions" class="text-center py-4">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <p class="text-muted mt-2 text-xs mb-0">Loading questions...</p>
                </div>

                <div v-else>
                  <div class="d-flex justify-content-between align-items-center mb-3 gap-3 flex-wrap">
                    <p class="text-muted mb-0 text-x">
                      Assigning to <span class="fw-semibold text-dark">{{ active_assign_section_label }}</span>
                    </p>
                    <div class="input-group input-group-sm w-50 rounded">
                      <input
                        type="text"
                        class="form-control text-xs"
                        placeholder="Search questions..."
                        v-model="question_search"
                      >
                    </div>
                  </div>

                  <div class="table-responsive">
                    <table class="table table-bordered table-hover align-middle mb-0">
                      <thead class="table-header text-white">
                        <tr class="text-x">
                          <th class="text-center">Assign</th>
                          <th>Question</th>
                          <th>Type</th>
                          <th>Number</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="q in filtered_questions" :key="q.id" class="text-xs">
                          <td class="text-center">
                            <span v-if="q.is_dependent" class="badge bg-light text-secondary border text-xxs fw-semibold">
                              Dependent
                            </span>
                            <div v-else class="form-check form-switch d-flex justify-content-center mb-0">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  :id="'assign-question-' + q.id"
                                  :checked="q.is_assigned"
                                  :disabled="q.is_saving"
                                  @change="toggle_existing_question_assignment(q)"
                                >
                              </div>
                          </td>
                          <td>
                            <span class="d-block">{{ q.question_text || 'No question text' }}</span>
                            <span v-if="q.is_dependent" class="badge bg-warning-subtle text-dark border border-warning-subtle text-xxs fw-semibold mt-1">
                              Dependent question
                            </span>
                          </td>
                          <td>{{ q.question_type_label || 'Unknown type' }}</td>
                          <td>{{ q.question_number || '-' }}</td>
                          <td>
                              <span
                                class="badge "
                                :class="q.is_saving ? 'bg-warning text-dark text-xs' : (q.is_dependent ? 'bg-warning-subtle text-dark text-xs border border-warning-subtle' : (q.is_assigned ? 'bg-success text-xs' : 'bg-secondary text-xs fw-semibold'))"
                              >
                                {{ q.is_saving ? 'Saving...' : (q.is_dependent ? 'Dependent' : (q.is_assigned ? 'Assigned' : 'Available')) }}
                              </span>
                            </td>
                        </tr>
                        <tr v-if="filtered_questions.length === 0 && !is_loading_questions">
                          <td colspan="5" class="text-center py-3 text-muted text-xs">
                            {{ question_list.length === 0 ? 'No questions available' : 'No matching questions found' }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="d-flex justify-content-between align-items-center mt-3 gap-3 flex-wrap">
                    <small class="text-muted text-xs">
                      Showing {{ filtered_questions.length }} of {{ question_list.length }} questions
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <div
      class="modal fade"
      id="edit_main_section_modal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-x">Edit Main Section</p>
            <button
              type="button"
              class="modal-btn-close btn-close"
              aria-label="Close"
              data-bs-dismiss="modal"
              @click="close_edit_main_section_modal"
            ></button>
          </div>
          <div class="modal-body">
            <div class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xs">Main Section Name:</label>
              <input
                type="text"
                v-model.trim="current_edit_main_section.main_section_name"
                class="modal-form-control form-control text-xs"
                placeholder="Enter main section name"
              />
              <small v-if="edit_main_section_name_error" class="text-danger p-2 text-xs">
                Please enter a main section name
              </small>
            </div>
            <div class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xs">Description:</label>
              <textarea
                v-model.trim="current_edit_main_section.main_section_description"
                class="modal-form-control form-control text-xs"
                rows="3"
                placeholder="Enter main section description"
              ></textarea>
            </div>
          </div>
          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button
              type="button"
             class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
              @click="save_edited_main_section"
              :disabled="editing_main_section || deleting_main_section"
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <div
      class="modal fade"
      id="edit_sub_section_modal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-x">Edit Sub Section</p>
            <button
              type="button"
              class="modal-btn-close btn-close"
              aria-label="Close"
              data-bs-dismiss="modal"
              @click="close_edit_section_modal"
            ></button>
          </div>
          <div class="modal-body">
            <div class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xs">Section Name:</label>
              <input
                type="text"
                v-model.trim="current_edit_section.name"
                class="modal-form-control form-control text-xs"
                placeholder="Enter sub section name"
              />
              <small v-if="edit_section_name_error" class="text-danger p-2 text-xs">
                Please enter a section name
              </small>
            </div>
          </div>
          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button
              type="button"
             class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
              @click="save_edited_section"
              :disabled="editing_main_section"
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <div
      class="modal fade"
      id="create_question_modal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-x">Create Questions</p>
            <button type="button" class="modal-btn-close btn-close" aria-label="Close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body d-flex flex-column flex-grow-1 overflow-auto">
            <div class="flex-grow-1 overflow-auto">
              <div
                v-for="(form, index) in question_forms"
                :key="form.id"
                class="card rounded-3 border-top-0 p-2 mb-3"
              >
                <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center">
                  <span>Question {{ index + 1 }}</span>
                  <div>
                    <button
                      type="button"
                      class="btn btn-primary-dark btn-sm rounded-3 text-x shadow me-2"
                      @click="add_question_form"
                    >
                      <i class="fas fa-plus text-white"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary-dark btn-sm rounded-3 text-x shadow"
                      @click="remove_question_form(index)"
                      :disabled="question_forms.length <= 1"
                    >
                      <i class="fas fa-trash text-white"></i>
                    </button>
                  </div>
                </div>

                <div class="card-body">
                  <div class="mb-3">
                    <label class="modal-form-label form-label text-xs">
                      Question Text <span class="text-danger fs-6">*</span>
                    </label>
                    <input
                      v-model="form.question_text"
                      type="text"
                      class="modal-form-control form-control text-xs rounded-3 p-3 shadow-sm"
                      required
                      placeholder="e.g Are you a director of a company?"
                    />
                  </div>

                  <div class="mb-3">
                    <label class="modal-form-label form-label text-xs">
                      Question Description
                    </label>
                    <input
                      v-model="form.question_description"
                      type="text"
                      class="modal-form-control form-control text-xs rounded-3 p-3 shadow-sm"
                      placeholder="Enter question description"
                    />
                  </div>

                  <div class="mb-3">
                    <label class="modal-form-label form-label text-xs">
                      Question Type <span class="text-danger fs-6">*</span>
                    </label>
                    <select
                      v-model="form.question_type_id"
                      class="modal-form-select form-select text-xs rounded-3 p-2 shadow-sm"
                      required
                      @change="handle_question_type_change_for_form(form)"
                      :disabled="question_types_loading"
                    >
                      <option value="" disabled hidden>
                        {{ question_types_loading ? 'Loading Question Types...' : 'Select Type' }}
                      </option>
                      <option v-for="type in question_types" :key="type.id" :value="type.id">
                        {{ type.formatted_type }}
                      </option>
                    </select>
                  </div>

                  <div class="mb-3">
                    <label class="modal-form-label form-label text-xs">Is question mandatory?</label>
                    <select
                      v-model="form.is_mandatory"
                      class="modal-form-select form-select text-xs rounded-3 p-2 shadow-sm"
                      required
                    >
                      <option :value="true">Yes</option>
                      <option :value="false">No</option>
                    </select>
                  </div>

                  <div v-if="form.show_option_inputs" class="mt-3">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <label class="form-label fw-bold small mb-0">Options</label>
                      <button
                        type="button"
                        @click="add_option_input(form)"
                        class="btn btn-primary-dark btn-sm rounded-3 text-xs shadow me-2"
                      >
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>

                    <div
                      v-for="(option, option_index) in form.option_inputs"
                      :key="option_index"
                      class="mb-3 position-relative"
                    >
                      <input
                        v-model="form.option_inputs[option_index]"
                        type="text"
                        class="modal-form-control form-control text-xs rounded-3 p-2 shadow-sm"
                        :placeholder="'Option ' + (option_index + 1)"
                      />
                      <span
                        @click="remove_option_input(form, option_index)"
                        class="position-absolute end-0 top-50 translate-middle-y me-2"
                        v-if="form.option_inputs.length > 2"
                      >
                        <i class="fas fa-times small-icon text-dark"></i>
                      </span>
                    </div>
                  </div>

                  <dependent-questions-panel
                    v-if="form.show_option_inputs"
                    class="mt-3"
                    v-model="form.dependant_questions"
                    :trigger-options="get_trigger_options(form)"
                    :question-types="question_types"
                    :question-types-loading="question_types_loading"
                    :disabled="creating_question"
                  />

                  <div class="mb-3">
                    <label class="modal-form-label form-label text-xs">Question Number:</label>
                    <input
                      v-model.number="form.question_number"
                      type="number"
                      class="modal-form-control form-control text-xs rounded-3 p-2 shadow-sm"
                      placeholder="e.g. 1"
                    />
                  </div>
                </div>
              </div>

              <small v-if="question_text_error" class="text-danger p-2 text-xs fw-bold d-block">
                Please complete the required question fields.
              </small>
            </div>
          </div>
          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button
              type="button"
             class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
              @click="save_all_questions"
              :disabled="creating_question"
            >
              {{ question_forms.length > 1 ? 'Save All Questions' : 'Save Question(s)' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <div
      class="modal fade"
      id="edit_question_modal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-x">Edit Question</p>
            <button
              type="button"
              class="modal-btn-close btn-close"
              aria-label="Close"
              data-bs-dismiss="modal"
              @click="close_edit_question_modal"
            ></button>
          </div>
          <div class="modal-body">
            <div class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xs">
                Question Text <span class="text-danger fs-6">*</span>
              </label>
              <input
                v-model="current_edit_question.question_text"
                type="text"
                class="modal-form-control form-control text-xs rounded-3 p-3 shadow-sm"
                placeholder="Question text"
              />
            </div>

            <div class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xs">
                Question Description
              </label>
              <input
                v-model="current_edit_question.question_description"
                type="text"
                class="modal-form-control form-control text-xs rounded-3 p-3 shadow-sm"
                placeholder="Enter question description"
              />
            </div>

            <div class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xs">
                Question Number
              </label>
              <input
                v-model.number="current_edit_question.question_number"
                type="number"
                class="modal-form-control form-control text-xs rounded-3 p-3 shadow-sm"
                placeholder="e.g. 1"
              />
            </div>

            <div class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xs">
                Question Type <span class="text-danger fs-6">*</span>
              </label>
              <select
                v-model="current_edit_question.question_type_id"
                class="modal-form-select form-select text-xs rounded-3 p-2 shadow-sm"
                required
                @change="handle_question_type_change_for_edit(current_edit_question)"
                :disabled="question_types_loading"
              >
                <option value="" disabled hidden>
                  {{ question_types_loading ? 'Loading Question Types...' : 'Select Type' }}
                </option>
                <option v-for="type in question_types" :key="type.id" :value="type.id">
                  {{ type.formatted_type }}
                </option>
              </select>
            </div>

            <div class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xs">Is question mandatory?</label>
              <select
                v-model="current_edit_question.is_mandatory"
                class="modal-form-select form-select text-xs rounded-3 p-2 shadow-sm"
                required
              >
                <option :value="true">Yes</option>
                <option :value="false">No</option>
              </select>
            </div>

            <div v-if="current_edit_question.show_option_inputs" class="mt-3">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <label class="form-label fw-bold small mb-0">Options</label>
                <button
                  type="button"
                  @click="add_option_input(current_edit_question)"
                  class="btn btn-primary-dark btn-sm rounded-3 text-xs shadow me-2"
                >
                  <i class="fas fa-plus"></i>
                </button>
              </div>

              <div
                v-for="(option, option_index) in current_edit_question.option_inputs"
                :key="option_index"
                class="mb-3 position-relative"
              >
                <input
                  v-model="current_edit_question.option_inputs[option_index]"
                  type="text"
                  class="modal-form-control form-control text-xs rounded-3 p-2 shadow-sm"
                  :placeholder="'Option ' + (option_index + 1)"
                />
                <span
                  @click="remove_option_input(current_edit_question, option_index)"
                  class="position-absolute end-0 top-50 translate-middle-y me-2"
                  v-if="current_edit_question.option_inputs.length > 2"
                >
                  <i class="fas fa-times small-icon text-dark"></i>
                </span>
              </div>
            </div>

            <small v-if="edit_question_error" class="text-danger p-2 text-xs fw-bold d-block">
              Please complete the required question fields.
            </small>
          </div>
          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button
              type="button"
              class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
              @click="save_edited_question"
              :disabled="editing_question"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</div>
